import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/memeye-dolgu-uygulamasi-dogal-dolgunluk-ve-sekillendirme/page.tsx");
